module.exports = __webpack_public_path__ + "static/media/buzzer.093eed4f.mp3";